import {Button, Divider} from '@material-ui/core';
import {createStyles, makeStyles} from '@material-ui/core/styles';
import useLoadDetails from 'components/hooks/useLoadDetails';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';

const InstanceReadOnlyDetail = ({history, location}: any) => {
  const styles = useStyles();
  return (
    <>
      <div className={styles.header}>
        <h2 className={styles.title}>{i18n2._('Detalle de la instancia')}</h2>
        <Divider variant="middle" className={styles.divider} />
        <div className={styles.button}>
          <Button
            title={i18n2._('Volver')}
            variant="contained"
            onClick={history.goBack}
            size="medium"
            color={'primary'}
          >
            {i18n2._('Volver')}
          </Button>
        </div>
      </div>
      <InstanceReadOnlyDetailGrid id={location.state.key} />
    </>
  );
};

const InstanceReadOnlyDetailGrid = ({id}: any) => {
  const ids = [id.iD_Instance, id.iD_Course];
  const loadCollabo = useLoadDetails('collaboratorJoinedWithAttended', ids);
  return (
    <IntegrityRoleGrid
      dataSource={loadCollabo}
      rowId={['iD_Instance', 'iD_Course', 'employee_Nr']}
      allowIntegrity={false}
      allowActions={false}
      height={'60vh'}
      exportName="Instance-detail-export"
    >
      <Column caption={i18n2._('#Instancia')} dataField="iD_Instance" />
      <Column caption={i18n2._('#Curso')} dataField="iD_Course" />
      <Column caption={i18n2._('Nombre')} dataField="name" />
      <Column caption={i18n2._('CWID')} dataField="cwid" />
      <Column caption={i18n2._('Nombre del curso')} dataField="name_Course" />
      <Column
        caption={i18n2._('Fecha de expiración')}
        dataField="expiration_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.expiration_Date)}
      />
      <Column caption={i18n2._('Sector')} dataField="name_Sector" />
      <Column caption={i18n2._('Duración')} dataField="duration" />
      <Column caption={i18n2._('Calificacion')} dataField="score" />
      <Column caption={i18n2._('Intento')} dataField="attempt" />
      <Column caption={i18n2._('En tiempo')} dataField="onTime" />
      <Column caption={i18n2._('Presente')} dataField="present" />
      <Column caption={i18n2._('Aprobado')} dataField="approved" />
    </IntegrityRoleGrid>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    header: {
      position: 'relative',
    },
    title: {
      textAlign: 'center',
    },
    divider: {
      marginBottom: 10,
    },
    button: {
      position: 'absolute',
      paddingRight: 30,
      right: 0,
      top: 0,
      textAlign: 'right',
    },
  }),
);

export default InstanceReadOnlyDetail;
